<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
};
</script>

<style>

.visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 200ms linear;
}

.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 200ms, opacity 200ms linear;
}

.visible_pop {
  visibility: visible;
  opacity: 1;
  transform: scale(1);
  box-shadow: 0px 6px 24px rgba(0,0,0,0);
  transition: all 150ms ease-in;
}

.hidden_pop {
  visibility: hidden;
  opacity: 0;
  transform: scale(1.1);
  box-shadow: 0px 3px 18px rgba(0,0,0,0.2);
  transition: all 150ms ease-out;
}

.full-screen {
  width: 100vw;
  height: 100vh;
}

.fix-to-bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
}

.soft-shadow {
  filter: drop-shadow(12px 6px 12px rgba(165, 165, 165, 0.51));
}
</style>
